// @flow strict

/**
 * Singleton empty array and object so we don't create new ones in mapper and
 * render methods.
 */
export const emptyArray: [] = Object.freeze([]);
// $FlowFixMe[cannot-resolve-name]
export const emptyObject: $TEMPORARY$Object$freeze<{}> = Object.freeze({});
